const CDN_AVATARS_PREFIX = 'https://cdn.a.team/avatars/defaults';

export const isDefaultProfileImage = (url: string) => {
  return url.startsWith(CDN_AVATARS_PREFIX);
};
